import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormBuilderComponent } from './form-builder.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { SchemaTitlePipe } from './schema-title.pipe';
import { OtherFieldsPipe } from './other-fields.pipe';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { GroupFieldsPipe } from './group-fields.pipe';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { OtherFieldsByTypePipe } from './other-fields-by-type.pipe';

@NgModule({
  declarations: [
    FormBuilderComponent,
    SchemaTitlePipe,
    OtherFieldsPipe,
    OtherFieldsByTypePipe,
    GroupFieldsPipe
  ],
  providers: [],
  imports: [
    CommonModule,
    NzFormModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    NzCheckboxModule,
    NzListModule,
    NzButtonModule,
    NzIconModule,
    DragDropModule,
    NzDropDownModule,
    NzToolTipModule,
    NzPopoverModule,
    NzTagModule,
    NzDrawerModule,
    NzEmptyModule,
    NzDividerModule,
    NzAlertModule,
    NzInputNumberModule,
    NzSliderModule
  ],
  exports: [FormBuilderComponent]
})
export class FormBuilderModule {}
